import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const KEY = "asap_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    try {
      if (!localStorage.getItem(KEY)) setVisible(true);
    } catch {}
  }, []);
  if (!visible) return null;
  const set = (choice) => {
    try { localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() })); } catch {}
    setVisible(false);
  };
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-md z-50" data-testid="cookie-banner">
      <div className="bg-asap-deep text-white border-2 border-asap-yellow shadow-hard p-4">
        <div className="flex items-start gap-3">
          <Cookie size={22} className="text-asap-yellow shrink-0"/>
          <div className="flex-1">
            <div className="text-xs uppercase tracking-[0.3em] text-asap-yellow font-bold">Cookies</div>
            <div className="font-display text-lg uppercase">We use essential cookies</div>
            <p className="text-white/70 text-sm mt-1">Essential cookies keep you logged in and payments secure. Optional analytics help us improve. Read our <a href="/legal#cookie" className="text-asap-yellow underline font-bold">Cookie Policy</a>.</p>
            <div className="mt-3 flex gap-2 flex-wrap">
              <button data-testid="cookie-accept-all" onClick={() => set("all")} className="px-3 py-1.5 bg-asap-yellow text-asap-deep font-display uppercase text-xs border-2 border-asap-yellow">Accept all</button>
              <button data-testid="cookie-essential" onClick={() => set("essential")} className="px-3 py-1.5 border-2 border-asap-yellow/40 text-asap-yellow font-bold uppercase text-xs hover:bg-asap-yellow/10">Essential only</button>
            </div>
          </div>
          <button onClick={() => set("essential")} className="p-1 text-white/50 hover:text-white"><X size={16}/></button>
        </div>
      </div>
    </div>
  );
}
